import CRC32 from './crc32.js';

const fpJS = require('@fingerprintjs/fingerprintjs');

export default {

    browserId: null, 
    hasSent: false,
    
    /**
     * 
     * @returns {string}
     */  
    getId: async function(){
        if(!this.browserId && localStorage){
            const browserId = localStorage.getItem('przBrwId');
            if(browserId && browserId.length){
                //console.log('storage UID', browserId);
                this.browserId = browserId;
            }
        }
        
        if(!this.browserId){
            //this.generateId().then( (res) => { this.browserId = res; });
            this.browserId = await this.generateId();
            if(localStorage && this.browserId){
                //console.log('set UID in storage '+ this.browserId);
                // store in browser
                localStorage.setItem('przBrwId', this.browserId);
            }
            this.sendId();
        }
        
        return this.browserId;
    },
        
    /**
     * 
     * @returns {string}
     */  
    generateId: async function(){
        try {
            const fp = await fpJS.load();
            const result = await fp.get();
            //console.log('generated UID '+ result.visitorId);
            return result.visitorId;
        }
        catch (e) {
            console.log(e);
            return null;
        }
    },
    
    sendId(){
        if(!this.browserId || this.hasSent){
            return ;
        }
        
        this.hasSent = true;
        
        const l = window.location;
        let url = l.protocol+'//'+l.hostname;
        
        if(process && process.env && process.env.VUE_APP_DEV_STORE){
            // vue development environment
            url = url + process.env.VUE_APP_DEV_STORE;
        }
        else{
            // website environment
            url = url + l.path.pathname.substring(0, 6);
        }
        
        // add query parameters
        url = url + '/beacon/fp/q/hash/' + this.browserId + '.' + CRC32.hash(window.location.href);
        
        //console.log('send UID '+url);
        
        if(navigator && typeof navigator.sendBeacon === 'function'){
            // send using "sendBeacon" because it's non blocking
            //console.log('sendBeacon', this.url, data);
            navigator.sendBeacon(url);
        }
        else{
            //console.log('TODO: sendBeacon not supported');
            var xhr = new XMLHttpRequest();
            xhr.open("GET", url, false); // third parameter of `false` means synchronous
            xhr.send();
        }
    }
    
};

//class UserId {
//    
//    constructor() {
//        this.id = null;
//    }
//    
//    getId(){
//        if(!this.id && localStorage){
//            const id = localStorage.getItem('przId');
//            if(id && id.length){
//                console.log('storage UID', id);
//                this.id = id;
//            }
//        }
//        
//        if(!this.id){
//            this.generateId().then( (res) => { this.id = res; });
//            if(localStorage && this.id){
//                console.log('set UID in storage '+ this.id);
//                // store in browser
//                localStorage.setItem('przId', this.id);
//            }
//            this.sendId();
//        }
//        
//        return this.id;
//    }
//    
//    async generateId(){
//        try {
//            const fp = await fpJS.load();
//            const result = await fp.get();
//            console.log('generated UID '+ result.visitorId);
//            return result.visitorId;
//        }
//        catch (e) {
//            console.log(e);
//            return null;
//        }
//    };
//    
//    sendId(){
//        if(!this.id){
//            return ;
//        }
//        
//        const l = window.location;
//        let url = l.protocol+'//'+l.hostname;
//        
//        if(process && process.env && process.env.VUE_APP_DEV_STORE){
//            // vue development environment
//            url = url + process.env.VUE_APP_DEV_STORE;
//        }
//        else{
//            // website environment
//            url = url + l.path.pathname.substring(0, 6);
//        }
//        // add query parameters
//        url = url + '/beacon/fp/q/hash/' + this.id + '.' + CRC32.hash(window.location.href);
//        
//        console.log('UID send ', url);
//        
//        if(navigator && typeof navigator.sendBeacon === 'function'){
//            // send using "sendBeacon" because it's non blocking
//            //console.log('sendBeacon', this.url, data);
//            navigator.sendBeacon(url);
//        }
//        else{
//            //console.log('TODO: sendBeacon not supported');
//            var xhr = new XMLHttpRequest();
//            xhr.open("GET", url, false); // third parameter of `false` means synchronous
//            xhr.send();
//        }
//    }
//    
//};
//
//export { UserId };